<label (click)="toggleRadio()"
       (mouseenter)="startVisualiser()"
       (mouseleave)="stopVisualiser()"
       [class.align-horizontal]="alignHorizontal"
       [class.disabled]="disabled"
       [class.margin-none]="noMargin"
       [class.selected]="selected"
       [class.with-icon]="iconName || iconPath"
       [class.work-ui-radio--card]="cardStyle"
       [for]="id"
       [ngClass]="{ 'work-action-element': cardStyle }"
       class="work-ui-radio">
  <p [innerHTML]="label | translate"></p>
  @if (visualizerFilePath) {
    <div class="work-ui-radio__visualiser">
      <img [src]="visualizerPlaceholderFilePath"
           [alt]="'AKTIONSVISUALISIERUNG_PLATZHALTER' | translate">
      @if (playVisualiser) {
        <img
          [class.work-ui-radio__visualiser--hidden]="hideVisualizer"
          [src]="visualizerFilePath"
          [alt]="'AKTIONSVISUALISIERUNG' | translate"
          class="work-ui-radio__visualiser-gif">
      }
    </div>
  }
  <input
    (blur)="onTouched()"
    [checked]="selected"
    [disabled]="disabled"
    [id]="id"
    [name]="name"
    [value]="value"
    type="radio"
    data-testid="radio__native-input" />
  @if (!iconName && !iconPath) {
    <span class="work-ui-radio__checkmark"></span>
  }
  @if (iconName) {
    <work-ui-icon
      [fontSize]="alignHorizontal ? 36 : 28"
      [name]="iconName" />
  }
  @if (iconPath) {
    <img [src]="iconPath" [alt]="'ICON' | translate" width="32" height="32" />
  }
</label>
